/**
 * @author Rohman Widiyanto
 * @email rohmansca@gmail.com
 * @create date 2022-03-09 03:06:20
 * @modify date 2022-03-09 03:06:20
 */
import { Theme } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import { colors, verticalCentered } from 'assets'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabPanelWrapper: {
      backgroundColor: 'white',
      marginBottom: theme.spacing(4)
    },
    titleWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(3)
    },
    title: {
      ...verticalCentered,
    },
    formRow: {
      marginBottom: theme.spacing(2),
      alignItems: 'start'
    },
    date: {
      '& svg': {
        fill: colors.primary.main
      }
    },
    autocomplete: {
      '& .MuiInputBase-root.MuiOutlinedInput-root': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(5)
      }
    },
    accordion: {
      borderBottom: `1px solid ${colors.border.primary}`,
      '&:before': {
        opacity: 0
      },
      '&.Mui-expanded': {
        border: 'none',
        '& .MuiAccordionSummary-root': {
          display: 'none'
        }
      }
    },
    greenGradingItem: {
      paddingBottom: theme.spacing(1),
      borderBottom: `1px solid ${colors.border.primary}`,
    },
    buttonWrapper: {
      flexWrap: 'wrap',
      justifyContent: 'center',
      '& button': {
        marginTop: `${theme.spacing(2)} !important`
      },
      [theme.breakpoints.up('md')]: {
        justifyContent: 'end'
      }
    },
    iconRounded: {
      width: 20,
      height: 20,
      backgroundColor: 'white',
      '& svg': {
        height: 16,
        fill: theme.palette.primary.main,
      }
    },
    buttonRounded: {
      borderRadius: theme.spacing(8),
      '&:hover': {
        '& svg': {
          fill: theme.palette.primary.dark
        }
      }
    },
    warningIcon: {
      fill: theme.palette.warning.main,
      width: 75,
      height: 75
    }
  })
)
